import { render, staticRenderFns } from "./admissioncollegeandmajor.vue?vue&type=template&id=365b8e4a&scoped=true&"
import script from "./admissioncollegeandmajor.vue?vue&type=script&lang=js&"
export * from "./admissioncollegeandmajor.vue?vue&type=script&lang=js&"
import style0 from "./admissioncollegeandmajor.vue?vue&type=style&index=0&id=365b8e4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b8e4a",
  null
  
)

export default component.exports